export const DDC_INVENTORY_TYPEDSEARCH_INIT = 'ddc.inventory.typedSearch.init';

const typedSearchInitiated = [];

function typedSearchInit({
	currentTarget: element,
	currentTarget: { tagName, value: elementValue }
}) {
	let eventObject;
	if (tagName !== 'INPUT' || typedSearchInitiated.indexOf(element) === -1) {
		let value;

		// push to array so text input event fires once per element
		if (tagName === 'INPUT') {
			typedSearchInitiated.push(element);
			value = elementValue;
		} else {
			const field = element.closest('.facetlist-keyword');
			const input = field && field.querySelector('input[name="search"]');
			value = input && input.value;
		}

		eventObject = {
			eventType: DDC_INVENTORY_TYPEDSEARCH_INIT,
			eventData: {
				element,
				search: value || ''
			}
		};
	}

	return eventObject;
}

export default typedSearchInit;
